import React from "react";
import { Button, Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom";

import { AlertComponent } from "../../components/shared/alert.component";
import { AppState } from "../../store/root.reducer"
import { TfaForLogin } from "./store/auth.actions";
import { TfaType } from "./store/auth.reducer";

export const TfaConfirmPage = () => {
    const auth = useSelector((state: AppState) => state.auth);
    const tfaState: TfaType = auth.tfa;

    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    const [showAlert, setShowAlert] = React.useState<boolean>(false);
    const [code, setCode] = React.useState<string>('');

    const onConfirm2FALogin = () => {
        setShowAlert(true);
        if(!tfaState.token) return;
        dispatch(TfaForLogin({token: tfaState.token, code, navigate}));
    }

    return (
        <>
            <div className="container">
                {auth.authError && showAlert ? 
                    <AlertComponent
                        variant="danger"
                        onClose={setShowAlert}
                        text={auth.authError} /> : <></>
                }

                <Form.Group className="mb-3" controlId='tfaCode'>
                    <Form.Label>2FA Code from {tfaState.method}</Form.Label>
                    <Form.Control 
                        value={code}
                        onChange={e => setCode(e.target.value)}
                        type="text"
                        placeholder="Enter 2FA Code"
                    />
                </Form.Group>
                <Button 
                    disabled={!code || code.length < 6 } 
                    variant='primary'
                    onClick={onConfirm2FALogin}
                >
                    Confirm
                </Button>
            </div>
        </>
    )
}